import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Order = function Order(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 23 23' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.832,0.446 C15.646,0.168 15.334,0 15,0 L11,0 L11,6 L19.535,6 L15.832,0.446 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L5,0 C4.666,0 4.354,0.168 4.168,0.446 L0.465,6 L9,6 L9,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,8 L0,8 L0,19 C0,19.552 0.448,20 1,20 L14,20 C14,20 14,19.999 14,19.998 C14,16.684 16.687,13.998 20,13.998 L20,8 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    x: "15",
    y: "18",
    width: "8",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    x: "18",
    y: "15",
    width: "2",
    height: "8",
    rx: "1"
  }))));
};

Order.displayName = 'Order';
export default Order;